import React, {useEffect, useState} from 'react';
import {Timeline} from 'antd';
import {useNavigate, useParams} from "react-router-dom";
import Pallet from "../../http_request/Model/pallet/Pallet";
import ComponentCard from "../../microComponents/elements/ComponentCard";
import Title from "../../microComponents/elements/Title";
import IconBtn from "../../microComponents/elements/IconBtn";
import {IoReturnDownBackOutline} from "react-icons/io5";

import {MdForklift, MdPrecisionManufacturing} from "react-icons/md";
import {AiOutlineDollar} from "react-icons/ai";
import {ImLab} from "react-icons/im";
import {PiWarehouseDuotone} from "react-icons/pi";
import {TbClockCancel} from "react-icons/tb";
import {FaRegClock} from "react-icons/fa";
import { FaHotel } from "react-icons/fa";
import { GrTransaction } from "react-icons/gr";
import { SlBasketLoaded } from "react-icons/sl";
import { IoPrintSharp } from "react-icons/io5";

const Transaction = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [items, setItems] = useState([]);
    const navigate = useNavigate();

    const getData = (type) => {


        let res = {}
        switch (type) {
            case 1:
                res = {dot: <SlBasketLoaded size={20} color='green'/>,}
                break;
            case 2:
                res = {dot: <GrTransaction size={20} color='blue'/>,}
                break;
            case 3:
                res = {dot: <ImLab size={20} color='orange'/>,}
                break;
            case 4:
                res = {dot: <IoPrintSharp size={20} color='gray'/>,}
                break;
            case 5:
                res = {dot: <AiOutlineDollar size={20} color='yellow'/>,}
                break;
            case 6:
                res = {dot: <TbClockCancel size={20} color='blue'/>,}
                break;
            default:
                res = {dot: <FaRegClock size={20} color='blue'/>,}
                break;
        }
        return res

    }

    useEffect(() => {
        Pallet.request({
            beforeSend: () => {
                setLoading(true)

            }, success: (res) => {

                setData(res)
            }, error: (error) => {

            }, final: () => {

            },


        }).addParams({id}).PalletTransaction();
    }, [id]);


    useEffect(() => {
        let x = []
        data.map(({children, label, type}, index) => {
            return x = [...x, {
                ...getData(type),
                children,
                label
            }]
        })

        setItems(x)
    }, [data]);
    return (<>
        <ComponentCard>
            <div className='flex justify-between'>
                <Title>تاریخچه اموال <span className='text-blue-600 mr-3'>{id}</span> </Title>
                <IconBtn color='blueIconBtn' TooltipText='بازگشت' onClick={() => {
                    navigate(-1);

                }}>
                    <IoReturnDownBackOutline size={20} color='white'/>
                </IconBtn>
            </div>
        </ComponentCard>


        <ComponentCard>

            <div className="py-5">
                <Timeline loading={loading}
                          mode='alternate'
                          items={items}

                />
            </div>
        </ComponentCard>


    </>);
};
export default Transaction;